import GLightbox from "glightbox";
import { forAllCallback, acfOnRender } from "../../../scripts/utils/helpers";
import { scrollTrigger } from "kwp-core/scripts/utils/animations";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    forAllCallback(".content-block.content-block--gallery", (el) => {
        const id = el.getAttribute("id");

        const init = () => {
            // Create lightbox
            const lightbox = GLightbox({
                touchNavigation: true,
                loop: true,
                selector: '[data-gallery="gallery-' + id + '"]',
            });

            lightbox.elements.forEach((item, key) => {
                // Open lightbox
                item.node.addEventListener("click", (e) => {
                    console.log("open", key);
                    lightbox.openAt(key);
                });

                const tween = gsap.fromTo(
                    item.node,
                    {
                        x: 50,
                        y: 50,
                        opacity: 0,
                    },
                    {
                        x: 0,
                        y: 0,
                        opacity: 1,
                        duration: 0.5,
                        delay: 0.2 + 0.1 * key,
                    }
                );
                ScrollTrigger.create({
                    trigger: el,
                    start: "top bottom",
                    end: "bottom top",
                    animation: tween,
                    once: false,
                    toggleActions: "restart none none reverse",
                });
            });
        };

        init();

        acfOnRender(() => {
            console.log("kwp-block-gallery");
            init();
        }, "kwp-block-gallery");
    });
};
